import button from './main.vue'
button.install = function (vue) {
  vue.component(button.name, button)
}
export default button



// WEBPACK FOOTER //
// ./src/ui/components/button/index.js